import React, { useEffect, useState } from 'react';

import OttSupportChat from '@ott/support-chat';

type SupportChatProps = React.ComponentProps<typeof OttSupportChat>;

const SupportChat = (props: SupportChatProps) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  return <OttSupportChat {...props} />;
};

export default SupportChat;
